/* eslint-disable react/prop-types,react/destructuring-assignment,prefer-destructuring */
import React, { Component } from 'react';
import { Slider, Tabs, Upload, Icon } from 'antd';
import _ from 'lodash';

import { FormRow } from '../../views/Form';
import ButtonList from '../../views/ButtonList';
import Button from '../../views/StyledButton';
import TermPreview from '../../views/TerminusTermsPreview';
import weightLabels from '../../utils/weightLabel';
import extend from './extend';
import { Top, Middle, Bottom, Flyout } from '../../views/Flyout';
import TerminusSingleFieldEntry from '../../views/TerminusSingleFieldEntry';
import { MAX_WEIGHT } from '../../../appConstants';

export default (bottle) => {
  bottle.constant('SINGLE_INDEX', 'single');
  bottle.constant('PREVIEW_INDEX', 'preview');

  bottle.factory('TerminusDrilldownAddVocabularyContainer', ({ SINGLE_INDEX, PREVIEW_INDEX }) => {
    class TerminusDrilldownAddVocabularyContainer extends Component {
      get changeTerms() {
        return (event) => {
          if (typeof event === 'string') {
            this.props.setAddVocabularyTerms(event);
          } else {
            this.props.setAddVocabularyTerms(_.get(event, 'target.value'));
          }
        };
      }

      get weightLabel() {
        return weightLabels(this.props.addingVocabularyWeight);
      }

      get showHelp() {
        return this.props.showHelp;
      }

      get tabsClicked() {
        return (key) => {
          this.props.setTabKey(key);
        };
      }

      get uploadProps() {
        const setAddVocabularyTerms = this.props.setAddVocabularyTerms;
        const existingTerms = this.props.addingVocabularyTerms;
        return {
          beforeUpload: () => false,
          showUploadList: false,
          accept: '.csv',
          onChange(info) {
            const reader = new FileReader();
            reader.onload = () => {
              const data = reader.result;
              setAddVocabularyTerms(`${existingTerms}\n${data.toString()}`);
            };
            reader.readAsText(info.file);
          },
        };
      }

      get save() {
        return this.props.saveAddingTerms;
      }

      render() {
        return (
          <Flyout>
            <Top>
              {window.FileReader && (
                <ButtonList line={false} compact>
                  <Upload {...this.uploadProps}>
                    <Button>
                      <Icon type="upload" />
                      {' '}
                      Import Terms from CSV
                    </Button>
                  </Upload>
                </ButtonList>
              )}
              <FormRow labelSpan={6} label="Weight" top height={80}>
                <Slider
                  min={0}
                  max={MAX_WEIGHT}
                  value={this.props.addingVocabularyWeight}
                  onChange={this.props.setAddVocabularyWeight}
                />
                <div>
                  {this.props.addingVocabularyWeight}
                  {': '}
                  {this.weightLabel}
                </div>
              </FormRow>
            </Top>
            <Middle>
              <Tabs activeKey={this.props.tabKey} onChange={this.tabsClicked}>
                <Tabs.TabPane tab="Terms" key={PREVIEW_INDEX}>
                  <TermPreview
                    keywords={this.props.addingVocabularyTerms}
                    defaultWeight={this.props.addingVocabularyWeight}
                    onChange={this.changeTerms}
                  />
                </Tabs.TabPane>
                <Tabs.TabPane tab="Single Field" key={SINGLE_INDEX}>
                  <TerminusSingleFieldEntry
                    value={this.props.addingVocabularyTerms}
                    onChange={this.changeTerms}
                  />
                </Tabs.TabPane>
              </Tabs>
            </Middle>
            <Bottom>
              <ButtonList>
                <Button
                  type="primary"
                  disabled={!this.props.canSave}
                  onClick={this.save}
                >
                  {this.replace ? 'Replace Terms' : 'Add/Update Terms'}
                </Button>
                <Button onClick={this.props.reset}>Reset</Button>
                <Button onClick={this.props.cancel}>Cancel</Button>
              </ButtonList>
            </Bottom>
          </Flyout>
        );
      }
    }

    return extend(TerminusDrilldownAddVocabularyContainer);
  });
};
